import React from 'react'
import SocialButton from './UI/SocialButton'
import { GoogleIcon, DiscordIcon, MicrosoftIcon } from './UI/SocialIcons'
import { useSocialSignIn } from '../hooks/useSocialSignIn'
import {
    getGoogleVariantClasses,
    getGoogleButtonStyles,
    getDiscordVariantClasses,
    getDiscordButtonStyles,
    getMicrosoftVariantClasses,
    getMicrosoftButtonStyles
} from '../utils/socialButtonStyles'

const GoogleSignInButton = ({
    variant = 'primary',
    size = 'md',
    className = '',
    children = 'Sign in with Google',
    disabled = false
}) => {
    const { isLoading, handleGoogleSignIn } = useSocialSignIn()
    const variantClasses = getGoogleVariantClasses(variant)
    const buttonStyles = getGoogleButtonStyles()

    return (
        <SocialButton
            icon={GoogleIcon}
            onClick={handleGoogleSignIn}
            variant={variantClasses}
            size={size}
            className={className}
            disabled={disabled}
            isLoading={isLoading}
            style={buttonStyles}
            loadingText="Signing in..."
            loadingSpinnerColor="border-purple-600"
        >
            {children}
        </SocialButton>
    )
}

export const DiscordSignInButton = ({
    variant = 'primary',
    size = 'md',
    className = '',
    children = 'Sign in with Discord',
    disabled = false
}) => {
    const { isLoading, handleDiscordSignIn } = useSocialSignIn()
    const variantClasses = getDiscordVariantClasses(variant)
    const buttonStyles = getDiscordButtonStyles()

    return (
        <SocialButton
            icon={DiscordIcon}
            onClick={handleDiscordSignIn}
            variant={variantClasses}
            size={size}
            className={className}
            disabled={disabled}
            isLoading={isLoading}
            style={buttonStyles}
            loadingText="Signing in..."
            loadingSpinnerColor="border-white"
        >
            {children}
        </SocialButton>
    )
}

export const MicrosoftSignInButton = ({
    variant = 'primary',
    size = 'md',
    className = '',
    children = 'Sign in with Microsoft',
    disabled = false
}) => {
    const { isLoading, handleMicrosoftSignIn } = useSocialSignIn()
    const variantClasses = getMicrosoftVariantClasses(variant)
    const buttonStyles = getMicrosoftButtonStyles()

    return (
        <SocialButton
            icon={MicrosoftIcon}
            onClick={handleMicrosoftSignIn}
            variant={variantClasses}
            size={size}
            className={className}
            disabled={disabled}
            isLoading={isLoading}
            style={buttonStyles}
            loadingText="Signing in..."
            loadingSpinnerColor="border-purple-600"
        >
            {children}
        </SocialButton>
    )
}

export const SocialLoginPanel = ({ className = '' }) => {
    return (
        <div className={`flex flex-col gap-3 ${className}`}>
            <GoogleSignInButton />
            <DiscordSignInButton />
            <MicrosoftSignInButton />
            <div className="text-center">
                <small className="text-gray-400">
                    Secure authentication powered by OAuth 2.0
                </small>
            </div>
        </div>
    )
}

export default GoogleSignInButton;